import { isPossiblePhoneNumber } from 'libphonenumber-js';
import validator from 'validator';
import i18n from './i18n';
const invalidWords = ['colgate', 'admin'];
const validNamePattern = /^[\p{L}\p{N} -]+$/u;

export const isProfileNameValid = (profileName) => {
  return profileName.length > 0 && profileName.length <= 50;
};

export const isUsernameValid = (username) => {
  if (username.length <= 3 || username.length > 15) return false;

  const lowerCasedUsername = username.toLowerCase();

  for (let i = 0; i < invalidWords.length; i++) {
    const invalidWord = invalidWords[i];
    if (lowerCasedUsername.indexOf(invalidWord) > -1) return false;
  }

  return isAlphanumeric(lowerCasedUsername);
};

export const isPasswordValid = (password) => {
  if (password.length < 10 || password.length > 100) return false;
  return true;
};

export const isAlphanumeric = (value) => {
  const regularExpression = /^[A-Za-z0-9]*$/g;
  return regularExpression.test(value);
};

export const isNameValid = (name) => {
  return name && name.length >= 1 && name.length <= 50 && validNamePattern.test(name);
};

export const isPetNameValid = (petName) => {
  return petName && petName.length <= 20 && validNamePattern.test(petName);
};

// AWS SES does not fully support unicode/nonascii in email addresses
// in particular the local address part
// https://docs.aws.amazon.com/ses/latest/dg/send-email-raw.html
// https://stackoverflow.com/questions/38808009/does-amazon-ses-support-utf-8-email-addresses
export const isEmailValid = (value = '') => {
  return validator.isEmail(value, { allow_utf8_local_part: false });
};

export const isPhoneNumberValid = (phoneNumber = '', countryCode = '') => {
  // International standard E164 defines a phone numbering plan with a maximum length of 15 digits
  // No minimum is necessarily set, and min/max length can vary country to country.
  // See discussion: https://stackoverflow.com/questions/14894899/what-is-the-minimum-length-of-a-valid-international-phone-number
  // See standard: https://www.itu.int/rec/T-REC-E.164/
  // Locale St Helena has had a minimum 4 length numbering plan
  // https://en.wikipedia.org/wiki/Telephone_numbers_in_Saint_Helena_and_Tristan_da_Cunha
  const MINIMUM_PHONE_NUMBER_LENGTH = 3;

  // The validation method nonstrictly checks if the input phone number is possible
  return countryCode
    ? isPossiblePhoneNumber(phoneNumber, countryCode)
    : phoneNumber.length > MINIMUM_PHONE_NUMBER_LENGTH;
};

export const keyValidate = (key) => {
  return key && i18n.exists(key) && i18n.t(key) != '';
};
